import React from 'react';
import { connect } from 'react-redux';

import Form from 'react-mui-lib/form-widgets/Form';
import TextField from 'react-mui-lib/form-widgets/TextField';
import Select from 'react-mui-lib/form-widgets/Select';
import Checkbox from 'react-mui-lib/form-widgets/Checkbox';
import registry from "react-mui-lib/registry";

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';

import DeleteButton from '../locallib/DeleteButton';


const EVENT_LABELS = {
    registration: 'Регистрация',
    game_created: 'Создание игры',
    game_paid: 'Оплата игры',
    game_extended: 'Продление игры',
    game_deleted: 'Удаление игры',
    nickname_changed: 'Смена ника',
    author_blocked: 'Автор заблокирован',
    author_unblocked: 'Автор разблокирован',
    deletion_requested: 'Запрос удаления аккаунта',
    deletion_canceled: 'Отмена удаления аккаунта',
    deletion_completed: 'Аккаунт удалён',
    agency_enabled: 'Активирован тариф Агентство',
    agency_disabled: 'Отключён тариф Агентство'
};


function formatDateTime(iso) {
    if (!iso) {
        return '';
    }
    const d = new Date(iso);
    if (isNaN(d.getTime())) {
        return iso;
    }
    return d.toLocaleString('ru-RU');
}


function renderPayload(row) {
    const p = row.payload || {};
    switch (row.event_type) {
        case 'registration': {
            const phone = row.phone ? `${row.phone}` : '';
            const locality = p.locality_name ? `город: ${p.locality_name}` : '';
            return [phone, locality].filter(Boolean).join(' — ');
        }
        case 'game_created':
        case 'game_deleted':
            return p.game_name || '';
        case 'game_paid':
        case 'game_extended':
            return `${p.game_name || ''}${p.out_sum ? ' — ' + p.out_sum + ' р.' : ''}`;
        case 'nickname_changed':
            return `с «${p.old_nickname || ''}» на «${p.new_nickname || ''}»`;
        case 'author_blocked':
            return p.games_unpublished ? `снято с публикации игр: ${p.games_unpublished}` : '';
        case 'author_unblocked':
            return '';
        case 'agency_enabled':
            return p.permanent ? 'навсегда' : (p.business_expires_at ? `до ${formatDateTime(p.business_expires_at)}` : '');
        case 'agency_disabled':
            return p.business_expires_at ? `был активен до ${formatDateTime(p.business_expires_at)}` : '';
        default:
            return JSON.stringify(p);
    }
}


class FranchiseForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            tab: 0,
            log: [],
            logLoading: false,
            logError: ''
        };

        this.controller = registry.get('franchise_form_controller');
        this.region_list_controller = registry.get('region_list_controller');
        this.locality_list_controller = registry.get('locality_list_controller');
        this.rest_client = registry.get('rest_client');
    }

    init(props) {
        const c = this;
        const entity_id = props.match.params.id;

        if (entity_id === undefined) {
            c.controller.editNew();
            c.setState({log: [], logError: ''});
        } else {
            c.controller.editExisting(entity_id);
            c.loadLog(entity_id);
        }
    }

    loadLog(entity_id) {
        this.setState({logLoading: true, logError: ''});
        this.rest_client.get(`franchise/${entity_id}/log`)
            .then(resp => {
                this.setState({
                    log: resp.data || [],
                    logLoading: false
                });
            })
            .catch(err => {
                this.setState({
                    logLoading: false,
                    logError: 'Ошибка загрузки лога: ' + err.message
                });
            });
    }

    componentWillMount() {
        this.init(this.props);
    }

    componentWillReceiveProps(new_props) {
        const c = this;

        if (new_props.location.pathname !== c.props.location.pathname) {
            c.init(new_props);
        }
    }

    handleTabChange(event, value) {
        this.setState({tab: value});
    }

    renderAuthorTab() {
        const c = this;
        const region_id = c.controller.getModel('region_id').getModelValue();
        const agencyEnabled = c.controller.getModel('agency_enabled').getModelValue();
        const agencyPermanent = c.controller.getModel('agency_permanent').getModelValue();
        const businessExpiresAt = c.controller.getModel('business_expires_at').getModelValue();

        return <Form controller={c.controller}
                     title_new="Новый автор"
                     title_edit="Автор"
                     actions_edit={[
                        <span key="spacer" style={{flexGrow: 1}} />,
                        <DeleteButton key="delete" dialogTitle="Удалить автора?" />
                    ]}>

            <div>
                <Select path="region_id"
                        options={c.region_list_controller.getAsOptions()}
                        label="Регион" />
            </div>
            <div>
                <Select path="locality_id"
                        options={c.locality_list_controller.getAsOptionsForRegion(region_id)}
                        label="Нас. пункт" />
            </div>
            <div>
                <TextField path="name"
                           label="Телефон (ID автора)"
                           disabled />
            </div>
            <div>
                <TextField path="description"
                           label="Примечание (видно только админу)"
                           multiLine={true} />
            </div>
            <div>
                <TextField path="organizer_name"
                            label="Ник для игроков" />
            </div>
            <div>
                <Checkbox path="payment_exempt"
                          label="Игры без оплаты (без Robokassa)" />
            </div>
            <div>
                <Checkbox path="is_blocked"
                          label="Заблокирован" />
            </div>
            <div>
                <Checkbox path="agency_enabled"
                          label="Активировать тариф Агентство" />
            </div>
            {agencyEnabled && (
                <div>
                    <Checkbox path="agency_permanent"
                              label="Навсегда (иначе 6 месяцев)" />
                </div>
            )}
            {agencyEnabled && businessExpiresAt && (
                <div>
                    <Typography color="textSecondary">
                        {agencyPermanent
                            ? 'Тариф Агентство активен навсегда'
                            : `Тариф Агентство активен до ${formatDateTime(businessExpiresAt)}`}
                    </Typography>
                </div>
            )}
        </Form>;
    }

    renderLogTab() {
        const { log, logLoading, logError } = this.state;
        const entity_id = this.props.match.params.id;

        return <Card>
            <CardContent>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16}}>
                    <Typography variant="h6">
                        Лог действий автора
                    </Typography>
                    {entity_id && (
                        <Button variant="outlined" size="small">
                            <Link href={`/admin/rest/franchise/${entity_id}/log_csv`} target="_blank" rel="noopener" color="inherit" underline="none">
                                Скачать лог
                            </Link>
                        </Button>
                    )}
                </div>

                {logLoading && <Typography>Загрузка...</Typography>}
                {logError && <Typography color="error">{logError}</Typography>}

                {!logLoading && !logError && log.length === 0 && (
                    <Typography color="textSecondary">Событий пока нет</Typography>
                )}

                {!logLoading && log.length > 0 && (
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Дата / время</TableCell>
                                <TableCell>Событие</TableCell>
                                <TableCell>Данные</TableCell>
                                <TableCell>Ник</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {log.map(row => (
                                <TableRow key={row.id}>
                                    <TableCell>{formatDateTime(row.created_at)}</TableCell>
                                    <TableCell>{EVENT_LABELS[row.event_type] || row.event_type}</TableCell>
                                    <TableCell>{renderPayload(row)}</TableCell>
                                    <TableCell>{row.nickname || ''}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                )}
            </CardContent>
        </Card>;
    }

    render() {
        const c = this;
        const { tab } = c.state;

        return <div>
            <Tabs value={tab}
                  onChange={(e, v) => c.handleTabChange(e, v)}
                  indicatorColor="primary"
                  textColor="primary">
                <Tab label="Автор" />
                <Tab label="Лог" />
            </Tabs>
            <div style={{marginTop: 16}}>
                {tab === 0 && c.renderAuthorTab()}
                {tab === 1 && c.renderLogTab()}
            </div>
        </div>;
    }
}


export default connect(
    /* mapStateToProps */ state => ({
        state__: state
    }),
    /* mapDispatchToProps */ state => ({
    })
)(FranchiseForm);
